module.exports = __webpack_public_path__ + "img/getting-on-track-like-a-pro.aeaf99b6.png";